import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout__bottom" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "fatc-teleport-target" }, null, -1)

import { computed, onMounted, ref } from 'vue';
import CountrySelect from '../CountrySelect.vue';
import GeoIpRedirect from '../GeoIpRedirect.vue';
import CompareNotification from '../CompareNotification.vue';
import CompareView from '../CompareView/CompareView.vue';
import SiteHeader from '../SiteHeader';
import SiteFooter from '../SiteFooter';
import useContext from '@/composables/useContext';
import CheckoutHeader from '../CheckoutHeader';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'StandardLayout',
  setup(__props) {

const { page } = useContext();
const { websiteText } = useWebsiteTexts();

const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
});

const checkoutHeader = computed(() => page.value?.type?.includes('Checkout'));

return (_ctx: any,_cache: any) => {
  const _component_router_page = _resolveComponent("router-page")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (!_unref(checkoutHeader))
        ? (_openBlock(), _createBlock(_unref(SiteHeader), { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(checkoutHeader))
        ? (_openBlock(), _createBlock(_unref(CheckoutHeader), { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(GeoIpRedirect),
      _createVNode(CountrySelect),
      _createElementVNode("main", null, [
        _createVNode(_component_router_page)
      ]),
      _createVNode(_unref(SiteFooter))
    ]),
    _createElementVNode("aside", _hoisted_1, [
      _hoisted_2,
      (isMounted.value)
        ? (_openBlock(), _createBlock(CompareNotification, {
            key: 0,
            title: _unref(websiteText)('compare_compare').value
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (isMounted.value)
        ? (_openBlock(), _createBlock(CompareView, {
            key: 1,
            title: _unref(websiteText)('compare_compare').value
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})